/** Roles that get the full internal app shell (not the reduced supplier portal nav). */
const INTERNAL_ROLES = new Set(['super_admin', 'admin', 'manager', 'member', 'viewer']);

/** Pure supplier logins: `supplier` without any internal org role. */
export function isSupplierPortalUser(roles: string[] | undefined | null): boolean {
  if (!roles?.length) return false;
  if (!roles.includes('supplier')) return false;
  return !roles.some((r) => INTERNAL_ROLES.has(r));
}
